module.exports = __webpack_public_path__ + "img/music-off.41db60f8.png";